import { faSortAsc, faSortDesc } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { MouseEvent as ReactMouseEvent, PointerEvent as ReactPointerEvent } from "react";
import { useTranslation } from "react-i18next";
import { ITableHeader } from "userful-chronos-app-common-js/dist/models/table/userfulTableInterface";
import ColumnResizeBar from "../components/ColumnResizeBar";
import { SortState } from "../UserfulTable2026";

import "./TableHeader.scss";

interface IProps {
    width: number;
    header: ITableHeader;
    sort?: SortState;
    onHeaderClick?: (headerID: string) => void;
    onHeaderWidthChange?: (headerID: string, width: number) => void;
    onDragHandlePointerDown?: (event: ReactPointerEvent<HTMLDivElement>) => void;
    isDragging?: boolean;
}

export default function TableHeader(props: IProps) {
    const { t } = useTranslation();

    const renderSortIcon = () => {
        if (!props.sort || props.sort.id !== props.header.id) {
            return;
        }

        return <FontAwesomeIcon icon={props.sort.direction === "asc" ? faSortAsc : faSortDesc} />;
    };

    const handleHeaderClick = (event: ReactMouseEvent<HTMLDivElement>) => {
        if (props.isDragging) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        props.onHeaderClick?.(props.header.id);
    };

    const handleHeaderMouseDown = (event: ReactMouseEvent<HTMLDivElement>) => {
        if (props.isDragging) {
            event.preventDefault();
            event.stopPropagation();
        }
    };

    return (
        <div
            className={`userful-table-header-cell noselect ${props.isDragging ? "is-dragging" : ""}`}
            onClick={handleHeaderClick}
            onMouseDown={handleHeaderMouseDown}
            onPointerDown={props.onDragHandlePointerDown}
        >
            <div className="userful-table-sub-header">{props.header.component}</div>
            <div className="userful-table-sub-header">{renderSortIcon()}</div>
            <ColumnResizeBar
                width={props.width}
                onResize={(width) => props.onHeaderWidthChange?.(props.header.id, width)}
            />
        </div>
    );
}
